const LOGO_SRC = `${process.env.PUBLIC_URL}/logo192.png`;

export function CopilotAvatar() {
  return (
    <div className="cop-msg-avatar">
      <img src={LOGO_SRC} alt="" className="cop-msg-avatar-img" draggable={false} />
    </div>
  );
}

export function CopilotThinking() {
  return (
    <div
      className="cop-thinking"
      aria-busy="true"
      aria-label="El copiloto está pensando"
    >
      <img
        src={LOGO_SRC}
        alt=""
        className="cop-thinking-logo"
        draggable={false}
      />
      <span className="cop-thinking-text">Consultando documentos…</span>
    </div>
  );
}
